import { render } from "./AddNewTask.vue?vue&type=template&id=47748306"
import script from "./AddNewTask.vue?vue&type=script&lang=js"
export * from "./AddNewTask.vue?vue&type=script&lang=js"

import "./AddNewTask.vue?vue&type=style&index=0&id=47748306&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__